<template>
  <div class="lg:ml-5  flex">
    <div class=" flex flex-wrap align-items-start pb-2">
      <ButtonGroup>
        <Button
          label="Shortages"
          @click="filterProjects('shortages')"
        />
        <Button
          label="Confirmed"
          @click="filterProjects('confirmed')"
        />
        <Button
          label="Unconfirmed"
          @click="filterProjects('unconfirmed')"
        />
      </ButtonGroup>
    </div>

    <div class=" flex  pb-2 pl-2">
      <ButtonGroup>
        <Button
          label="Today"
          @click="filterProjects('today')"
        />
        <Button
          label="3 Day"
          @click="filterProjects('3day')"
        />
        <Button
          label="Week"
          @click="filterProjects('week')"
        />
        <Button
          label="Month"
          @click="filterProjects('month')"
        />
      </ButtonGroup>
    </div>

    <div class="ml-auto w-3">
      <IconField>
        <InputIcon class="pi pi-search" />
        <InputText
          id="search"
          v-model="searchValue"
          type="search"
          class="pl-4 w-12"
          @change="doSearch()"
        />
      </IconField>
    </div>
  </div>


  <div class=" flex-auto lg:ml-5 bg-white">
    <DataTable
      :value="projects"
      sort-field="name"
      scrollable
      scroll-height="625px"
    >
      <template #empty>
        <div class="flex flex-wrap items-center justify-between gap-2 p-4">
          <p>No Subhires or Shortages have been found.</p>
        </div>
      </template>

      <template #footer />
      <Column
        field="projectNumber"
        header="Project Number"
        sortable
      />
      <Column
        field="name"
        header="Project Name"
        sortable
      />
      <Column
        field="start"
        header="Start Date"
        sortable
      />

      <Column
        field="projectManager"
        header="Project Manager"
        sortable
      />
      <Column
        field="shortages"
        header="Shortages"
        sortable
      >
        <template #body="slotProps">
          <Badge
            :value="slotProps.data.shortages"
            :severity="shortageSeverity(slotProps.data.shortages)"
          />
        </template>
      </Column>
      <Column
        field="confirmedSubs"
        header="Confirmed Subs"
        sortable
      >
        <template #body="slotProps">
          <Badge
            :value="slotProps.data.confirmedSubs"
            :severity="projectSeverity(slotProps.data.confirmedSubs)"
          />
        </template>
      </Column>
      <Column
        field="unconfirmedSubs"
        header="Unconfirmed Subs"
        sortable
      >
        <template #body="slotProps">
          <Badge
            :value="slotProps.data.unconfirmedSubs"
            :severity="stockSeverity(slotProps.data.unconfirmedSubs)"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
//Primevue Imports


import { ref, onMounted } from 'vue';

import { createProjects } from '@/data/faker'
import { stockSeverity, shortageSeverity, projectSeverity } from '@/shared/DataTableFunctions';

const projects = ref()
const searchValue = ref('');
const doSearch = () => {
    console.log('searching')
    if (searchValue.value.length > 3) {
        console.log(searchValue.value)
    }

}

// Populate contacts when the component is mounted
onMounted(() => {
    projects.value = createProjects(100); // Generate 100 contacts
});


//Filter contacts based on the filter button applied above
const filterProjects = (filter) => {
    console.log(filter)
}
</script>
